import React from "react";
import LoadingGif from "../images/loading.svg"
import "./Loading.css"
export default function Loading({width="auto", height="auto", justifyContent="center"}) {
    return(
        <div className={"loading"} style={{justifyContent:justifyContent}}>
            <img width={width} height={height} src={LoadingGif} alt="Chargement..."/>
        </div>
    )
}